import api from '../../api/app'
import Vue from 'vue'
// initial state
const state = {
    modalIsOpen: false,
    isAuthenticated: false,
    sessionToken: '',
    displayName: '',
    deviceName: '',
    deviceUUID: '',
    swimmingPoolName: '',
    all: []
};

// getters
const getters = {

};

// actions
const actions = {
    authenticateUser ({ commit, state }, credentials) {
        api.authenticate(session => {
            if(session.status == 200) {
                commit('setSession', session.data);
                Vue.notify({
                    group: 'app',
                    type: 'success',
                    title: 'Authentification réussie',
                    text: 'Bienvenue '+session.data.display_name+'  !',
                });
            } else {
                Vue.notify({
                    group: 'app',
                    type: 'error',
                    title: 'Échec de l\'authentification',
                    text: 'Vérifiez vos identifiants ou la connexion',
                });
            }
        }, credentials, state.deviceUUID);
    },
    logout ({ commit }) {
        commit('destroySession');
        commit('surveys/destroySurveys', null, { root: true })
    },
    openModal ({ commit }) {
        commit('openModal');
    },
    closeModal ({ commit }) {
        commit('closeModal');
    },
    setDeviceUUID ({ commit }, uuid){
        commit('setDeviceUUID', uuid);
    }
};

// mutations
const mutations = {
    setSession (state, session) {
        state.isAuthenticated = true;
        state.sessionToken = session.session_token;
        state.displayName = session.display_name;
        state.deviceName = session.device.name;
        state.swimmingPoolName = session.swimming_pool.name;
        state.all = session;
    },
    destroySession (state) {
        state.isAuthenticated = false;
        state.sessionToken = '';
        state.all = [];
        state.displayName = '';
        state.deviceName = '';
        state.swimmingPoolName = '';
        state.modalIsOpen = false;
    },
    openModal (state) {
        state.modalIsOpen = true;
    },
    closeModal (state) {
        state.modalIsOpen = false;
    },
    setDeviceUUID (state, uuid) {
        state.deviceUUID = uuid;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
